import { Select } from '@nula/core-ui';
import { cva } from 'class-variance-authority';
import styles from './permission-select.module.css';

const permissionSelect = cva(styles.base);

const options = [
  { label: 'Can View', value: 'read' },
  { label: 'Can Edit', value: 'edit' },
  { label: 'Admin', value: 'admin' },
];

interface PermissionSelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  variant?: 'default' | 'plain';
}

/**
 * PermissionSelect — reusable Select wrapper for permission levels.
 *
 * Options: "Can View" (read), "Can Edit" (edit), "Admin" (admin).
 */
export function PermissionSelect({ value, onChange, disabled, variant }: PermissionSelectProps) {
  return (
    <Select
      size="sm"
      variant={variant}
      value={value}
      options={options}
      onChange={(v) => onChange(v as string)}
      disabled={disabled}
      className={permissionSelect()}
      style={{ '--permission-select-min-width': '120px' } as React.CSSProperties}
    />
  );
}
